import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useRecurly } from '@recurly/react-recurly';

import { Element, InputState } from '../constants.ts';
import useFormValidation from '../hooks/useFormValidation';
import SecurityCodeComponent from '../PaymentCardForm/SecurityCode';
import { Form, Label } from '../PaymentCardForm/index.styles';

const ExistingPaymentCvvForm = ({ onSuccess, onFailure, onSubmitAttempt, onFormValidityChange, innerRef }) => {
  const recurly = useRecurly();
  const [securityCodeState, setSecurityCodeState] = useState(InputState.Standard);

  useFormValidation([{ [Element.Cvv]: securityCodeState }], onFormValidityChange);

  const onFormSubmit = e => {
    e.preventDefault();
    onSubmitAttempt?.();
    recurly.token(innerRef.current, (err, token) => {
      if (err) {
        onFailure?.(err, 'existing_card');
      } else {
        onSuccess?.(token, 'existing_card');
      }
    });
  };

  return (
    <Form
      ref={innerRef}
      id="recurly-cvv-form-existing-payment"
      data-automation-test-element="recurly-cvv-form-existing-payment"
      onSubmit={onFormSubmit}
    >
      <Label>Security code</Label>
      <SecurityCodeComponent
        onSecurityCodeStateChange={state => setSecurityCodeState(state)}
        onFormValidityChange={onFormValidityChange}
      />
    </Form>
  );
};

ExistingPaymentCvvForm.defaultProps = {
  onSuccess: () => {},
  onFailure: () => {},
  onSubmitAttempt: () => {},
};

ExistingPaymentCvvForm.propTypes = {
  onSuccess: PropTypes.func,
  onFailure: PropTypes.func,
  onSubmitAttempt: PropTypes.func,
  onFormValidityChange: PropTypes.func.isRequired,
  innerRef: PropTypes.shape({ current: PropTypes.shape({}) }).isRequired,
};

export default ExistingPaymentCvvForm;
